import React, { useEffect, useState } from 'react';
import { Sparkles, Clock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Виджет «Когда с вами» — компактная карточка расписания приёма Светланы.
 * Аня — всегда, Светлана — по расписанию из /api/schedule.
 * Никакого локального времени / индикатора «сейчас работает» — по договорённости в бэклоге.
 */
export default function ScheduleWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let stopped = false;
    fetch(`${API}/api/schedule`)
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((d) => { if (!stopped) setData(d); })
      .catch(() => {/* fallback: не показываем ничего */});
    return () => { stopped = true; };
  }, []);

  if (!data) return null;
  const days = data.days || [];
  const vacation = data.vacation || {};

  return (
    <div className="mt-5 border border-ink/10 p-6" data-testid="schedule-widget">
      <div className="flex items-center gap-2 mb-4">
        <Clock size={16} className="text-wine shrink-0" />
        <h3 className="font-heading text-xl text-ink">Когда с вами</h3>
      </div>

      {/* Аня — всегда */}
      <div className="flex items-start gap-3 py-2 border-b border-ink/8" data-testid="schedule-anya-row">
        <Sparkles size={13} className="text-gold mt-1 shrink-0" />
        <div className="flex-1">
          <div className="text-ink text-[15px]">Аня AI</div>
          <div className="text-ink/60 text-[13px]">всегда, любое время</div>
        </div>
      </div>

      {/* Светлана — по расписанию */}
      <div className="pt-3">
        <div className="text-[11px] tracking-[0.18em] uppercase text-wine/70 mb-2">Светлана — лично</div>
        {vacation.enabled ? (
          <div className="text-ink/70 italic text-[14px] leading-relaxed" data-testid="schedule-vacation-note">
            До {vacation.until || '…'} — {vacation.note || 'вне связи'}
          </div>
        ) : (
          <ul className="space-y-1" data-testid="schedule-days">
            {days.map((d) => (
              <li key={d.key} className="flex items-baseline justify-between gap-3 text-[14px]">
                <span className="text-ink/85 w-8 shrink-0">{d.label}</span>
                <span className={`text-right ${d.hours ? 'text-ink' : 'text-ink/45 italic'}`}>
                  {d.hours || d.note || 'выходной'}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p className="mt-4 text-[12.5px] text-ink/55 leading-relaxed">
        Можно оставить заявку сейчас — Аня передаст, Светлана ответит в ближайший рабочий час.
      </p>
    </div>
  );
}
